import { useEffect } from "react";

export function useKeyboardNavigationClass() {
  useEffect(() => {
    let keyboardMode = false;
    const body = document.body;

    const enableKeyboardMode = (e) => {
      if (e.key === "Tab" && !keyboardMode) {
        keyboardMode = true;
        body.classList.add("using-keyboard");
      }
    };

    const disableKeyboardMode = () => {
      if (keyboardMode) {
        keyboardMode = false;
        body.classList.remove("using-keyboard");

        if (!body.classList.length) {
          body.removeAttribute("class");
        }
      }
    };

    window.addEventListener("keydown", enableKeyboardMode);
    window.addEventListener("mousedown", disableKeyboardMode);
    window.addEventListener("pointerdown", disableKeyboardMode);
    window.addEventListener("touchstart", disableKeyboardMode);

    return () => {
      window.removeEventListener("keydown", enableKeyboardMode);
      window.removeEventListener("mousedown", disableKeyboardMode);
      window.removeEventListener("pointerdown", disableKeyboardMode);
      window.removeEventListener("touchstart", disableKeyboardMode);
    };
  }, []);
}